var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcCloud(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 16C10 14.0222 10.5865 12.0888 11.6853 10.4443C12.7841 8.79981 14.3459 7.51809 16.1732 6.76121C18.0004 6.00433 20.0111 5.8063 21.9509 6.19215C23.8907 6.578 25.6725 7.53041 27.0711 8.92894C28.4696 10.3275 29.422 12.1093 29.8079 14.0491C30.1937 15.9889 29.9957 17.9996 29.2388 19.8268C28.4819 21.6541 27.2002 23.2159 25.5557 24.3147C23.9112 25.4135 21.9778 26 20 26H9C7.14348 26 5.36301 25.2625 4.05025 23.9498C2.7375 22.637 2 20.8565 2 19C2 17.1435 2.7375 15.363 4.05025 14.0503C5.36301 12.7375 7.14348 12 9 12C9.58566 11.9998 10.1692 12.0711 10.7375 12.2125",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcCloud);
export default __webpack_public_path__ + "static/media/ic_cloud.0673849c2a8ef7284ed36b9d52c882bb.svg";
export { ForwardRef as ReactComponent };